export default __webpack_public_path__ + "static/media/Group9220.4fbecd6a.svg";